<template>
  <transition
      name="fadein"
      mode="in-out"
  >
    <div class="fareConditions">
      <swiper class="fareConditions__head" ref="swiperTop" :options="swiperOptionTop">
        <swiper-slide v-for="(fare, index) in classes"
                      :key="index+'header'"
        >
          <div class="fareConditions__tab">
            <span>{{ fare }}</span>
          </div>
        </swiper-slide>
      </swiper>
      <div class="fareConditions__detail">
        <swiper ref="swiperThumbs"
                :options="swiperOptionThumbs"
                >
          <swiper-slide v-for="(fare, index) in classes"
                        :key="index+'conditions'"
          >
            <div v-for="(condition, index) in conditions"
                 :key="index+'x'"
                 class="fareConditions__row"
            >
              <div class="fareConditions__item">
                <i class="fas" :class="'fa-'+condition.icon"></i>
                <span>{{ $t(`shopping_lib.${condition.service}_service`) }}</span>
              </div>
              <div class="fareConditions__value">
                <span>{{ normalizedName(`${condition.service}_${fare}`) }}</span>
              </div>
            </div>

            <div class="fareConditions__policies" v-if="familyFareRules.showPolicies">
              <span v-html="normalizedName(`policy_${fare}`)"></span>
            </div>
            <div class="fareConditions__policies" v-if="familyFareRules.showNotice">
              <span v-html="normalizedName('common_policies')"></span>
            </div>
          </swiper-slide>
          <div class="fareConditions__prev" slot="button-prev">
            <i class="fas fa-chevron-left"></i>
          </div>
          <div class="fareConditions__next" slot="button-next">
            <i class="fas fa-chevron-right"></i>
          </div>
        </swiper>
      </div>
      <div class="fareConditions__footer">
        <button class="btn btn-primary" @click="$emit('close-modal')">
          <i class="fas fa-times mr-2"></i>
          <span>{{ $t("close") }}</span>
        </button>
      </div>
    </div>
  </transition>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper"
import 'swiper/css/swiper.css'
import FareConditions from './FareConditions'

// https://github.com/surmon-china/surmon-china.github.io/blob/source/projects/vue-awesome-swiper/examples/30-thumbs-gallery.vue

export default {
  mixins: [
    FareConditions
  ],
  name: 'FareConditionsMobile',
  components: {
    Swiper,
    SwiperSlide
  },
  data () {
    return {
      swiperOptionTop: {
        loop: true,
        loopedSlides: 4, // looped slides should be the same
        // spaceBetween: 5,
        centeredSlides: true,
        slidesPerView: 3,
        touchRatio: 0.2,
        slideToClickedSlide: true
      },
      swiperOptionThumbs: {
        loop: true,
        loopedSlides: 4, // looped slides should be the same
        spaceBetween: 10,
        centeredSlides: true,
        slidesPerView: 'auto',
        slideToClickedSlide: true,
        navigation: {
          nextEl: '.fareConditions__next',
          prevEl: '.fareConditions__prev'
        }
      }
    }
  },
  computed: {
    classes: function () {
      return this.familyFares.map(x => x.split('_')[0])
    }
  },
  mounted() {
    this.$nextTick(() => {
      const swiperTop = this.$refs.swiperTop.$swiper
      const swiperThumbs = this.$refs.swiperThumbs.$swiper
      swiperTop.controller.control = swiperThumbs
      swiperThumbs.controller.control = swiperTop
    })
  }
}
</script>

<style lang="sass">
.fareConditions
  position: fixed
  left: 0
  top: 0
  width: 100%
  height: 100vh
  background: var(--color-overlay-50)
  padding: 4.5rem 0.5rem 5rem
  z-index: 9999
  display: flex
  flex-direction: column
  &__head
    display: flex
    background-color: var(--color-surface)
    border-radius: var(--b-radius-md) var(--b-radius-md) 0 0
    width: 100%
    min-height: 2.5rem
  &__tab
    display: flex
    justify-content: center
    align-items: flex-end
    padding: .5rem 1rem
    height: 100%
    color: var(--color-onSurface)
    text-align: center
    background-color: var(--color-overlay-10)
    font-size: var(--font-size-sm)
    line-height: var(--font-size-base)
    box-sizing: border-box
  &__detail
    background-color: var(--color-surface)
    color: var(--color-onSurface)
    font-size: var(--font-size-sm)
    width: 100%
    padding: 0 2rem
    height: calc(100% - 4.5rem)
    overflow-y: auto
  &__row
    display: flex
    width: 100%
    justify-content: space-between
    align-items: baseline
    border-top: 1px solid var(--color-overlay-10)
    padding: .5rem 0
    flex-direction: column
    &:first-child
      padding-top: 1.5rem
      border-top: 0
    i
      width: 1.75rem
      min-width: 1.75rem
      text-align: left
  &__item
    display: flex
    align-items: baseline
    i
      opacity: .6
  &__value
    display: flex
    justify-content: flex-end
    text-align: left
    padding-left: 1.75rem
    font-weight: 500
  &__policies
    padding: 1rem 0 0.5rem
    display: flex
    flex-direction: column
    span
      margin: .5rem 0
  &__footer
    background-color: var(--color-surface)
    color: var(--color-onSurface)
    padding: .5rem
    display: flex
    justify-content: flex-end
    border-top: 1px solid var(--color-overlay-10)
    border-radius:  0 0 var(--b-radius-md) var(--b-radius-md)
  &__prev, &__next
    position: fixed
    top: 0
    bottom: 0
    left: 0
    right: 0
    display: flex
    margin: auto
    height: 6rem
    width: 6rem
    justify-content: center
    align-items: center
    z-index: 100
    font-size: var(--font-size-xl)
    color: var(--color-primary)
    transition: background-color .2s ease
    will-change: background-color
    &:focus
      background-color: var(--color-overlay-10)
    &:active
      background-color: var(--color-overlay-20)
      i
        opacity: 1
    i
      width: 2.5rem
      text-align: center
      transition: opacity .2s ease
      will-change: opacity
      opacity: .6
  &__prev
    right: initial
    border-radius: 0 50% 50% 0
    left: -1.7rem
  &__next
    left: initial
    border-radius: 50% 0 0 50%
    right: -1.7rem
.swiper-slide-active
  .fareConditions
    &__tab
      box-shadow: inset 0 -2px 0 0 var(--color-primary)
      background-color: var(--color-surface)
</style>
